import axios from "@/api/axios"

export default {
  fetchClients(params = {}) {
    return axios.get("/clients", { params })
  }
}
